import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import type { InputBaseProps } from '@mui/material/InputBase'
import type { SxProps } from '@mui/material/styles'

type InputBoxProps = {
    inputBaseProps?: InputBaseProps
    label: string | React.ReactNode
    onChange?: (value: string) => void
    name?: string
    props?: unknown
    value?: string
    onClick?: () => void
    type?: string
    labelSx?: SxProps
    disabled?: boolean
    onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    endAdornment?: React.ReactNode
    startAdornment?: React.ReactNode
    maxLength?: number
    exLabel?: string
    sx?: SxProps
    autoFocus?: boolean
    defaultValue?: string
    placeholder?: string
    onFocus?: () => void
    onBlur?: () => void
}

const InputBox = ({ label, onChange, name, value, type = 'text', disabled, autoFocus, endAdornment, startAdornment, ...props }: InputBoxProps) => {
    return (
        <InputStyled
            id={name || ''}
            label={label}
            name={name}
            value={value}
            type={type}
            autoComplete={type === 'text' ? 'new-password' : undefined}
            disabled={disabled}
            variant="filled"
            autoFocus={autoFocus}
            onChange={e => onChange?.(e.target.value)}
            {...props}
            placeholder=""
            slotProps={{
                input: {
                    endAdornment: endAdornment,
                    startAdornment: startAdornment
                }
            }}
        />
    )
}

const InputStyled = styled(TextField)(() => ({
    '& .MuiInputBase-root': {
        backgroundColor: '#ffffff!important',
        borderRadius: '6px',
        border: '1px solid rgba(226, 232, 240, 1)',
        height: '50px',
        '&.MuiFilledInput-root': {
            '&::after': {
                borderBottom: 'none!important'
            },
            '&.MuiFilledInput-root': {
                '&::before': {
                    borderBottom: 'none!important'
                },
                '&::after': {
                    borderBottom: 'none!important'
                },
                '&::hover': {
                    borderBottom: 'none!important'
                }
            }
        }
    },
    '.MuiInputBase-input': {
        backgroundColor: 'transparent',
        height: '50px'
    }
}))

export default InputBox
